// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32sdG","content":"styles_content__L40Sk","tableWrap":"styles_tableWrap__31KK_"};